import React from "react";
import AppSpinner from "./AppSpinner";

export default function AppLoader() {
    return <div className="d-flex w-100 text-center p-5 app-loader justify-content-center align-items-center">
        <AppSpinner />
    </div>
}
